import axios from "axios";

//const apibaseurl='https://viivapi.trigma.ai/';
//const apibaseurl=apijsondata.apibaseurl;
//const apibaseurl='http://mmmuatapi-env.eba-y3ze7gkv.us-east-1.elasticbeanstalk.com/';
const apibaseurl='https://uat-mmm-api.trigma.ai/';
//http://trigmammmbackend-env.eba-rqnbsrhr.ap-south-1.elasticbeanstalk.com

//const apibaseurl='https://uat-mmm-api.trigma.ai/';

//const macaddress1= globalvar.getmacaddress();
const macaddress= '10.18.2.121';
const Api = axios.create({
    baseURL: apibaseurl,
    params: {
        auth_key:'4549A1EA-9C0D-43A1-98E7-F2B5D13095DC',
        mac_address:macaddress,
        uid:1,
        appid:4,
        token:'test23062022'
      }
});
export default Api;